import { render } from "./BuildingFilterModal.vue?vue&type=template&id=efa7094a"
import script from "./BuildingFilterModal.vue?vue&type=script&lang=js"
export * from "./BuildingFilterModal.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1189531127/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__